var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemQuieroir1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DA322A",
    d: "M11.992 4.571L3.429 13.793 11.385 22.857 20.571 13.794z",
    transform: "translate(-53.000000, -362.000000) translate(0.000000, 339.000000) translate(20.000000, 16.000000) translate(33.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.752 11.403L12.597.248c-.33-.33-.865-.33-1.195 0L.248 11.403C.089 11.56 0 11.776 0 12c0 .224.089.439.248.598l11.154 11.154c.165.166.381.248.598.248.216 0 .432-.082.597-.248l11.155-11.154c.159-.16.248-.374.248-.598 0-.224-.09-.439-.248-.597zm-7.185-.408l-2.486 2.486c-.188.188-.434.282-.681.282-.246 0-.492-.094-.68-.282-.376-.376-.376-.985 0-1.361l.85-.85H9.259v5.133c0 .531-.43.962-.962.962s-.963-.43-.963-.962v-6.096c0-.531.431-.962.963-.962h5.26L12.523 8.31c-.376-.376-.376-.985 0-1.361.375-.376.985-.376 1.36 0l2.685 2.684c.376.376.376.986 0 1.362z",
    transform: "translate(-53.000000, -362.000000) translate(0.000000, 339.000000) translate(20.000000, 16.000000) translate(33.000000, 7.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemQuieroir1);
export default __webpack_public_path__ + "static/media/system-quieroir-1.7be803fa.svg";
export { ForwardRef as ReactComponent };